<template>
	<Icon v-bind="$props">
		<svg
			viewBox="0 0 428 86"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<defs>
				<polygon
					id="path-1"
					points="0.8056 0.2392 55.973 0.2392 55.973 55.4072 0.8056 55.4072"
				/>
				<polygon
					id="path-3"
					points="0.283 0.323 36.312 0.323 36.312 66.0797 0.283 66.0797"
				/>
				<polygon id="path-5" points="0 0.4721 99.0429 0.4721 99.0429 85 0 85" />
			</defs>
			<g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
				<g transform="translate(-506.000000, -119.000000)">
					<g transform="translate(506.000000, 119.000000)">
						<path
							d="M249.6742,24.9156 C242.1832,24.9156 236.0902,31.0096 236.0902,38.4996 C236.0902,45.9906 242.1832,52.0846 249.6742,52.0846 C257.1652,52.0846 263.2582,45.9906 263.2582,38.4996 C263.2582,31.0096 257.1652,24.9156 249.6742,24.9156 M249.6742,66.0846 C234.4642,66.0846 222.0902,53.7096 222.0902,38.4996 C222.0902,23.2906 234.4642,10.9156 249.6742,10.9156 C264.8842,10.9156 277.2582,23.2906 277.2582,38.4996 C277.2582,53.7096 264.8842,66.0846 249.6742,66.0846"
							fill="#FFFFFF"
						/>
						<g id="Group-5" transform="translate(372.000000, 10.676900)">
							<mask id="mask-2" fill="white">
								<use xlink:href="#path-1" />
							</mask>
							<g id="Clip-4" />
							<path
								d="M28.3896,14.2392 C20.8986,14.2392 14.8056,20.3332 14.8056,27.8232 C14.8056,35.3142 20.8986,41.4072 28.3896,41.4072 C35.8796,41.4072 41.9736,35.3142 41.9736,27.8232 C41.9736,20.3332 35.8796,14.2392 28.3896,14.2392 M28.3896,55.4072 C13.1796,55.4072 0.8056,43.0332 0.8056,27.8232 C0.8056,12.6132 13.1796,0.2392 28.3896,0.2392 C43.5996,0.2392 55.9736,12.6132 55.9736,27.8232 C55.9736,43.0332 43.5996,55.4072 28.3896,55.4072"
								id="Fill-3"
								fill="#FFFFFF"
							/>
						</g>
						<path
							d="M199.3075,19.9063 C200.0065,18.7873 200.8125,17.7183 201.7235,16.7023 C202.6325,15.6893 203.7195,14.7783 204.9795,13.9713 C206.2405,13.1673 207.6755,12.5193 209.2865,12.0303 C210.8965,11.5403 212.7165,11.2933 214.7485,11.2933 C217.1285,11.2933 219.8965,11.7153 223.0475,12.5543 L221.6825,25.4733 C220.9105,25.3353 220.1405,25.1583 219.3705,24.9483 C218.7405,24.8103 218.0395,24.6863 217.2705,24.5813 C216.4985,24.4763 215.7995,24.4243 215.1685,24.4243 C212.9265,24.4243 210.8445,24.7393 208.9195,25.3683 C206.9925,26.0003 205.3295,26.8763 203.9295,27.9953 C202.5275,29.1153 201.4095,30.4643 200.5685,32.0403 C199.7275,33.6143 199.3075,35.3133 199.3075,37.1333 L199.3075,64.7603 L184.8115,64.7603 L184.8115,12.6593 L197.9415,12.6593 L199.3075,19.9063 Z"
							id="Fill-6"
							fill="#FFFFFF"
						/>
						<path
							d="M309.35,12.6597 C311.302,12.6597 313.468,12.9407 315.841,13.4987 C318.214,14.0617 320.448,15.1117 322.542,16.6507 C324.636,18.1917 326.399,20.3277 327.83,23.0597 C329.262,25.7887 329.977,29.3257 329.977,33.6677 L329.977,64.7607 L315.481,64.7607 L315.481,34.2737 C315.481,32.6697 315.219,31.3077 314.694,30.1907 C314.168,29.0717 313.468,28.1817 312.592,27.5187 C311.716,26.8547 310.719,26.3657 309.599,26.0507 C308.478,25.7357 307.357,25.5787 306.238,25.5787 C305.327,25.5787 304.329,25.7357 303.244,26.0507 C302.158,26.3657 301.143,26.8717 300.198,27.5707 C299.252,28.2697 298.465,29.1767 297.834,30.2957 C297.204,31.4127 296.889,32.7397 296.889,34.2737 L296.889,64.7607 L282.393,64.7607 L282.393,12.6597 L294.788,12.6597 L296.889,16.6507 C298.563,15.4597 300.449,14.4987 302.543,13.7617 C304.637,13.0267 306.905,12.6597 309.35,12.6597"
							id="Fill-8"
							fill="#FFFFFF"
						/>
						<g id="Group-12" transform="translate(334.000000, 0.676900)">
							<mask id="mask-4" fill="white">
								<use xlink:href="#path-3" />
							</mask>
							<g id="Clip-11" />
							<path
								d="M24.495,51.1557 C26,52.4927 27.977,53.1587 30.43,53.1587 C32.389,53.1587 34.351,52.7747 36.312,52.0037 L36.312,64.0997 C34.561,64.6547 32.705,65.1247 30.745,65.5067 C28.784,65.8867 26.822,66.0797 24.862,66.0797 C22.621,66.0797 20.485,65.7987 18.455,65.2377 C16.423,64.6767 14.603,63.7157 12.993,62.3487 C11.381,60.9847 10.104,59.1647 9.16,56.8887 C8.214,54.6137 7.741,51.7937 7.741,48.4327 L7.741,24.9017 L0.283,24.9017 L0.283,15.1337 L7.741,11.9827 L7.741,0.3227 L22.237,0.3227 L22.237,11.9827 L36.312,11.9827 L36.312,24.9017 L22.237,24.9017 L22.237,45.4627 C22.237,47.9227 22.989,49.8207 24.495,51.1557"
								id="Fill-10"
								fill="#FFFFFF"
								mask="url(#mask-4)"
							/>
						</g>
						<path
							d="M150.6327,52.0845 C144.3837,52.0845 139.1217,47.8385 137.5437,42.0845 C137.2297,40.9405 137.0487,39.7425 137.0487,38.5005 C137.0487,37.2575 137.2297,36.0595 137.5437,34.9155 C139.1217,29.1615 144.3837,24.9155 150.6327,24.9155 C158.1237,24.9155 164.2167,31.0095 164.2167,38.5005 C164.2167,45.9905 158.1237,52.0845 150.6327,52.0845 M150.6327,10.9155 C144.7027,10.9155 140.4257,12.8025 137.4067,15.9985 L135.4437,12.6595 L123.0487,12.6595 L123.0487,85.5585 L137.5437,85.5585 L137.5437,61.1465 C140.5547,64.2545 144.7927,66.0845 150.6327,66.0845 C165.8427,66.0845 178.2167,53.7105 178.2167,38.5005 C178.2167,23.2905 165.8427,10.9155 150.6327,10.9155"
							id="Fill-13"
							fill="#FFFFFF"
						/>
						<g id="Group-17" transform="translate(0.000000, 0.676900)">
							<mask id="mask-6" fill="white">
								<use xlink:href="#path-5" />
							</mask>
							<g id="Clip-16" />
							<path
								d="M49.5219,0.4721 C76.8719,0.4721 99.0429,17.1951 99.0429,37.8231 C99.0429,58.4511 76.8719,75.1741 49.5219,75.1741 C44.9379,75.1741 40.5049,74.6941 36.2929,73.8151 L36.2929,73.8151 L26.9219,84.1691 C25.3789,85.8731 22.5469,84.7821 22.5469,82.4831 L22.5469,82.4831 L22.5469,69.1401 C8.9789,62.4781 -0.000100000001,50.9451 -0.000100000001,37.8231 C-0.000100000001,17.1951 22.1719,0.4721 49.5219,0.4721 Z M68.6918,27.4345 C63.4088,27.4345 59.0568,31.3815 58.3998,36.4855 L51.7268,36.4855 C51.0968,33.0265 48.0738,30.4025 44.4338,30.4025 C40.7928,30.4025 37.7708,33.0265 37.1398,36.4855 L30.3718,36.4855 C29.7758,34.2095 27.7258,32.5225 25.2628,32.5225 C22.3358,32.5225 19.9628,34.8955 19.9628,37.8235 C19.9628,40.7495 22.3358,43.1225 25.2628,43.1225 C27.7258,43.1225 29.7768,41.4355 30.3718,39.1605 L37.1398,39.1605 C37.7708,42.6195 40.7928,45.2435 44.4338,45.2435 C48.0738,45.2435 51.0968,42.6195 51.7268,39.1605 L58.3998,39.1605 C59.0568,44.2645 63.4088,48.2115 68.6918,48.2115 C74.4288,48.2115 79.0808,43.5605 79.0808,37.8235 C79.0808,32.0855 74.4288,27.4345 68.6918,27.4345 Z"
								id="Combined-Shape"
								fill="#FFFFFF"
								mask="url(#mask-6)"
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	</Icon>
</template>

<script>
import Icon, { props } from './Icon'
export default {
	name: 'ProntoNameLogoIcon',
	components: { Icon },
	props,
}
</script>
